module.exports = __webpack_public_path__ + "img/sac-atendimento-mobile.96cd814e.png";